import React, { useState, useEffect } from 'react';
import ATable from 'components/Clinic/ClinicFinancials/ATable';
import { FancyAPlot } from 'components/Clinic/ClinicFinancials/APlot';
import { DefaultSwitch } from 'services/UIUtils';
import RevenuePlotWorker from '../../../workers/revenue-plot.worker?worker';
import RevenueTableWorker from '../../../workers/revenue-table.worker?worker';
import LoadingIndicator from './LoadingIndicator';

export const Revenue = ({ invoices, range }) => {
  const [net, setNet] = useState(false);

  return (
    <div className="stats">
      <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
        <DefaultSwitch
          onChange={(event, isInputChecked) => setNet(isInputChecked)}
          label="Net (excludes Stripe fees, HST and refunds)"
          padded={false}
          checked={net}
        />
        <br />
        <RevenueTable invoices={invoices} net={net} />
      </div>
      <RevenuePlot invoices={invoices} net={net} range={range} />
    </div>
  );
};

export const RevenuePlot = ({ invoices, net, range, showTitle }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const worker = new RevenuePlotWorker();
    worker.onmessage = (event) => {
      setData(event.data);
    };
    worker.postMessage({ invoices, net, range });
    return () => {
      worker.terminate();
    };
  }, [invoices, net, range]);

  return (
    <FancyAPlot
      datasets={data}
      title="Revenue"
      showTitle={showTitle}
      loading={!data}
      key={range?.name}
    />
  );
};

export const RevenueTable = ({ invoices, net }) => {
  const [data, setData] = useState();

  useEffect(() => {
    const worker = new RevenueTableWorker();
    worker.onmessage = (event) => {
      setData(event.data);
    };
    worker.postMessage({ invoices, net });
    return () => {
      worker.terminate();
    };
  }, [invoices, net]);

  return (
    <>
      {!data && <LoadingIndicator hasData={false} />}
      {data && <ATable headers={data.headers} rows={data.rows} className="h-full" />}
    </>
  );
};
